import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { StyledDialogTitle } from './styles';

function ResponsiveDialog({
  open,
  onClose,
  title,
  content, // Dialog content (can be text or JSX)
  actions, // Custom actions (buttons or other UI elements)
  fullScreenBreakpoint = 'sm'
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(fullScreenBreakpoint));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title"
    >
      {title && (
        <StyledDialogTitle
          id="responsive-dialog-title"
        >
          {title}
        </StyledDialogTitle>
      )}
      {content && <DialogContent>{content}</DialogContent>}
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  );
}

export default ResponsiveDialog;
